<div class="change-owner-container">
  <mat-card class="change-owner-card">
    <mat-card-header>
      <mat-card-title>Troca de síndico</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="info-row">
        <mat-icon color="primary">info</mat-icon>
        <span>Digite o e-mail do novo síndico. O novo síndico precisa estar cadastrado</span>
      </div>
      <form [formGroup]="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-mail do novo síndico</mat-label>
          <input matInput type="email" formControlName="email" placeholder="exemplo@dominio.com" />
          @if (form.controls.email.hasError('required')) {
            <mat-error>E-mail é obrigatório</mat-error>
          }
          @if (form.controls.email.hasError('email')) {
            <mat-error>E-mail inválido</mat-error>
          }
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="onSave()" [disabled]="saving || form.invalid">
        Salvar
      </button>
    </mat-card-actions>
  </mat-card>
</div>


